<template> 
    <div class="row g-6 g-xl-9" >  
        <div class="col-12 col-md-12 col-xl-12">  
            <CardRh :processando="processando"  v-if="turma">  
                <KDataTable :reload="reloadDatatable" :config="config"  @tableatualizada="tableatualizada( $event )"  :pesquisar="false"  >  
                    <th pesquisavel>Cpf</th>
                    <th>NF</th>
                    <th pesquisavel>Nome</th> 
                    <th style="min-width:130px" class="text-center" v-if="hasPermissao">Ações</th>  
                    <template v-slot:filtros>  
                        <input type="text" data-kt-docs-table-filter="turmaId" v-model="turma.id" hidden/>   
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-2">
                            <div class="mb-2">
                                <label for="ano" class="form-label">Ano</label>
                                <input @keyup="apertouEnter" type="number" step="1" min="2010" max="2500" v-model="ano" data-kt-docs-table-filter="ano" class="form-control form-control-solid" placeholder="ano"/>
                            </div> 
                        </div>   
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-2">
                            <div class="mb-2">
                                <label for="mes" class="form-label">Mês</label>
                                <input @keyup="apertouEnter" type="number"  step="0.001" min="0" max="10" v-model="mes" data-kt-docs-table-filter="mes" class="form-control form-control-solid" placeholder="Mês"/>
                            </div> 
                        </div>   
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                            <div class="mb-2">
                                <label for="disciplinaNome" class="form-label">Disciplina</label>
                                <input @keyup="apertouEnter" type="text" data-kt-docs-table-filter="disciplinaNome" v-model="disciplina" class="form-control form-control-solid" placeholder="Disciplina"/>
                            </div> 
                        </div> 
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                            <div class="mb-2">
                                <label for="usuarioNome" class="form-label">Instrutor</label>
                                <input @keyup="apertouEnter" type="text" data-kt-docs-table-filter="usuarioNome" class="form-control form-control-solid" placeholder="Instrutor"/>
                            </div> 
                        </div>  
                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-2">
                            <div class="mb-0">
                                <button type="button" class="btn btn-sm btn-pmes-primary mt-10" title="Matricular Lote" @click="refreshTable"> 
                                    <span class="menu-icon">
                                        <i class="fa fa-search fa-2x bi  "></i> 
                                    </span>
                                    Buscar
                                </button>   
                            </div> 
                        </div>  
                    </template>
                </KDataTable>   
            </CardRh>   
            <InstrutorPdf :modal="modal_visualizar" :dados="dados" :turmaId="turma.id"  :ano="ano" :mes="mes" :disciplina="disciplina" />
        </div>
    </div>
</template>

<script lang="ts">  
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import InstrutorService from   "@/service/v1/sigap/InstrutorService"  
    import { Options,Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
	import $ from "jquery"   
    import { PerfilConfig } from "@/core/config/PerfisConfig";   
    import InstrutorPdf from   "./_InstrutorPdf.vue"   
    import {  Prop   } from 'vue-property-decorator';  
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "TurmaRelatorioInstrutorIndex",
        components: {  CardRh , KDataTable, InstrutorPdf },   
    }) 
    export default class TurmaRelatorioInstrutorIndex extends Vue {
         
        @authStore.Getter
		public perfis!: any  

        @Prop( ) readonly turma!: any

        public processando = false; 
        public reloadDatatable = false ;
        public config: any = null; 
        public service = new InstrutorService();
        public modelo: any  = null ;  
        public ano: any  = null ;  
        public mes: any  = null ;  
        public disciplina: any  = null ;   
        public dados: any  = null ;  
 
        public modal_visualizar:any = 'modal_turma_relatorio_instrutor_pdf2' ;  

        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
         
        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }

        created(){ 
            this.config = {  ajax: {} , columns: [] , columnDefs: [] , order: [] };  
            this.config.ajax = { 
                url: this.service.getApiUrl() + '/Relatorio/Aula',
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length,  
                        "turmaId": () => (document.querySelector('[data-kt-docs-table-filter="turmaId"]')! as HTMLInputElement).value ,  
                        "ano": () => (document.querySelector('[data-kt-docs-table-filter="ano"]')! as HTMLInputElement).value ,  
                        "mes": () => (document.querySelector('[data-kt-docs-table-filter="mes"]')! as HTMLInputElement).value ,  
                        "disciplina": () => (document.querySelector('[data-kt-docs-table-filter="disciplinaNome"]')! as HTMLInputElement).value ,  
                        "instrutorAuxiliarNome": () => (document.querySelector('[data-kt-docs-table-filter="usuarioNome"]')! as HTMLInputElement).value ,  
                        "search": d.search.value
                    }
                    return dados; 
                } 
            };  
            this.config.columns = [ 
                { data: 'id', name: 'id' , class: 'text-center' ,  orderable: false }, 
                { data: 'numeroFuncional', name: 'numerofuncional' ,  orderable: false },
                { data: 'nome', name: 'nome',  orderable: false },  
            ];
            if(this.hasPermissao){
                this.pushColunaAcoes()
                this.config.columnDefs = [ 
                    {
                        targets: 3 ,
                        render: ( row, type, val, meta ) => {  
                            let texto = '' ; 
                            let buttom = '' ;  
                            for (var key in val) {  buttom = buttom + ' data-' + key + '="'+ val[key] +'"'  }     
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-show-aula-instrutor ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_visualizar  + '" title="Visualizar"><i class="fa fa-file-pdf"></i></button>';    
                            return texto;  
                        }, 
                    },  
                ];   
            }
        }     
  
        public tableatualizada( event ) {  
             $('[btn-show-aula-instrutor]').click(  (btn) => {  
                this.dados =   null; 
                setTimeout(() => {
                    this.dados =   $(btn.currentTarget).data();
                }, 100);  
            });   
             
        }  
 
        pushColunaAcoes(){ 
            this.config.columns.push({ data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' });
        }  

    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    }
</style>




  